// Login yapmayan (misafir) kullanıcıların oyuncu arama geçmişini
// tarayıcıda (localStorage) tutar. "Daha önce arattın" listesi için kullanılır.
const KEY = "cr_guest_player_history";
const MAX = 30;

export function getGuestHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function addGuestHistory(tag, name = "") {
  try {
    const t = (tag || "").toUpperCase().replace(/^#/, "");
    if (!t) return getGuestHistory();
    const list = getGuestHistory().filter((x) => x.tag !== t);
    list.unshift({ tag: t, name: name || "", added_at: new Date().toISOString() });
    const trimmed = list.slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(trimmed));
    return trimmed;
  } catch {
    return getGuestHistory();
  }
}

export function removeGuestHistory(tag) {
  try {
    const t = (tag || "").toUpperCase().replace(/^#/, "");
    const list = getGuestHistory().filter((x) => x.tag !== t);
    localStorage.setItem(KEY, JSON.stringify(list));
    return list;
  } catch {
    return getGuestHistory();
  }
}
